import styled from "styled-components";
import Div from "../Div";

const SectionStyle = styled(Div)`
  padding-top: ${({ theme }) => `calc(${theme.padding.base} * 5)`};
  padding-bottom: ${({ theme }) => `calc(${theme.padding.base} * 5)`};
`;

const Section = (props) => <SectionStyle {...props} as="section" />;

// eslint-disable-next-line
export default Section;
